import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as Pointer } from 'src/Images/icons/common/pointer.svg';
import { ReactComponent as Refresh } from 'src/Images/icons/common/refresh.svg';
import CreateGRN from 'src/components/PendingGrnVehicleEntry/Drawer/CreateGrn';
import UpdateGrn from '../Drawer/UpdateGrn';

function TableContent({ headers, setOpenGRNDrawer, openGRNDrawer }) {
  const vehicleTrackingReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const data =
    vehicleTrackingReducer?.vehicleTrackingAwaitingGrn?.vehicleTrackings;

  const [selectedVehicle, setSelectedVehicle] = useState(null); // For selection
  // Controls Drawer

  const [openGrnUpdate, setOpenGrnUpdate] = useState(null);

  return (
    <>
      <tbody>
        {data && data.length > 0 ? (
          data?.map((dataObj) => (
            <tr key={dataObj?.vehicle_tracking_code}>
              {headers.map((header) => (
                <td className="table-data" key={header.value}>
                  <div className="div-flex-row cg-5 div-align-center">
                    {header.value === 'status' ? (
                      <div className="div-flex-row cg-5 div-align-center">
                        <Pointer className="icon-size-xs" color="#F88F14" />
                        <span className="text-orange">
                          {dataObj[header.value]}
                        </span>
                      </div>
                    ) : header.value === 'vehicle_tracking_code' ? (
                      <div className="div-flex-row cg-5">
                        <input
                          type="checkbox"
                          className="checkbox-grey"
                          checked={
                            selectedVehicle === dataObj.vehicle_tracking_number
                          }
                          onChange={() =>
                            setSelectedVehicle(dataObj.vehicle_tracking_number)
                          }
                          disabled={dataObj.grn_unique_number}
                        />
                        <button className="icon-btn-none">
                          <span className="text-blue">
                            {dataObj[header.value]}
                          </span>
                        </button>
                      </div>
                    ) : header.value === 'sap_code' ? (
                      <div className="div-flex-row">
                        {dataObj[header.value] ? (
                          <span className="text-sm">
                            {dataObj[header.value]}
                          </span>
                        ) : (
                          dataObj.grn_unique_number && (
                            <button
                              className="icon-btn-none div-flex-row cg-5 div-align-center"
                              onClick={() =>
                                setOpenGrnUpdate(
                                  dataObj.vehicle_tracking_number,
                                )
                              }
                            >
                              <Refresh className="icon-size-sm text-blue" />
                              <span className="text-blue">Retry</span>
                            </button>
                          )
                        )}
                      </div>
                    ) : (
                      <span>{dataObj[header.value]}</span>
                    )}
                  </div>
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={5}>
              <div className="div-flex-row div-align-center">
                <span className="text-sm">No Pending GRN Vehicle Entry</span>
              </div>
            </td>
          </tr>
        )}
      </tbody>
      <CreateGRN
        openGRNDrawer={openGRNDrawer}
        setOpenGRNDrawer={setOpenGRNDrawer}
        selectedVehicle={selectedVehicle}
      />
      <UpdateGrn
        openGrnUpdate={openGrnUpdate}
        setOpenGrnUpdate={setOpenGrnUpdate}
      />
    </>
  );
}

export default TableContent;
